"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CheckboxBlankIcon = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const material_1 = require("@mui/material");
const CheckboxBlankIcon = ({ sx = [], ...otherProps }) => {
    return ((0, jsx_runtime_1.jsxs)(material_1.SvgIcon, { ...otherProps, sx: [
            ({ palette }) => ({
                width: "1em",
                height: "1em",
                fontSize: 16,
                color: palette.gray[40],
            }),
            ...(Array.isArray(sx) ? sx : [sx]),
        ], viewBox: "0 0 16 16", fill: "none", children: [(0, jsx_runtime_1.jsx)("rect", { width: "16", height: "16", rx: "4", fill: "currentColor" }), (0, jsx_runtime_1.jsx)("rect", { x: "1", y: "1", width: "14", height: "14", rx: "3", fill: "white" })] }));
};
exports.CheckboxBlankIcon = CheckboxBlankIcon;
